import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { GET_CATEGORIES } from "@/graphql/queries/categories-query";

const useCategories = (categoryType: CategoryType = "COURSE_CATEGORY") => {
  const { data: categoriesData, error, loading } = useQuery(GET_CATEGORIES);

  const data = useMemo(() => {
    if (categoriesData) {
      return categoriesData?.categories
        .filter((item) => item.categoryType.value === categoryType)
        ?.map((item) => ({
          value: item.id,
          label: item.name,
        }));
    }
    return [];
  }, [categoriesData, categoryType]);

  return { error, loading, data };
};

export default useCategories;
